const activeLocks = new Set();
let storedScrollY = 0;
let previousInlineStyles = null;

/**
 * Blocca lo scroll del body mantenendo la posizione corrente.
 * Supporta più lock contemporaneamente tramite identificatori univoci.
 * @param {string} [lockId='default']
 */
export function lockBodyScroll(lockId = 'default') {
    if (typeof document === 'undefined' || typeof window === 'undefined') {
        return;
    }

    const body = document.body;
    if (!body || activeLocks.has(lockId)) {
        return;
    }

    if (activeLocks.size === 0) {
        storedScrollY = window.scrollY || window.pageYOffset || 0;
        previousInlineStyles = {
            position: body.style.position,
            overflow: body.style.overflow,
            width: body.style.width,
            top: body.style.top
        };

        body.style.position = 'fixed';
        body.style.overflow = 'hidden';
        body.style.width = '100%';
        body.style.top = `-${storedScrollY}px`;
        body.classList.add('scroll-locked');
    }

    activeLocks.add(lockId);
}

/**
 * Ripristina lo scroll del body una volta rimosso l'ultimo lock attivo.
 * @param {string} [lockId='default']
 */
export function unlockBodyScroll(lockId = 'default') {
    if (typeof document === 'undefined' || typeof window === 'undefined') {
        return;
    }

    const body = document.body;
    if (!body || !activeLocks.has(lockId)) {
        return;
    }

    activeLocks.delete(lockId);

    if (activeLocks.size === 0) {
        body.classList.remove('scroll-locked');

        if (previousInlineStyles) {
            body.style.position = previousInlineStyles.position;
            body.style.overflow = previousInlineStyles.overflow;
            body.style.width = previousInlineStyles.width;
            body.style.top = previousInlineStyles.top;
        } else {
            body.style.position = '';
            body.style.overflow = '';
            body.style.width = '';
            body.style.top = '';
        }

        const html = document.documentElement;
        const previousScrollBehavior = html ? html.style.scrollBehavior : null;

        if (html) {
            html.style.scrollBehavior = 'auto';
        }

        if (typeof window.scrollTo === 'function') {
            try {
                window.scrollTo({ top: storedScrollY, left: 0, behavior: 'auto' });
            } catch (err) {
                window.scrollTo(0, storedScrollY);
            }
        }

        if (html && previousScrollBehavior !== null) {
            html.style.scrollBehavior = previousScrollBehavior;
        }

        previousInlineStyles = null;
        storedScrollY = 0;
    }
}

export default {
    lockBodyScroll,
    unlockBodyScroll
};
